import { render, staticRenderFns } from "./sideMenuMobie.vue?vue&type=template&id=68cb0724&"
import script from "./sideMenuMobie.vue?vue&type=script&lang=js&"
export * from "./sideMenuMobie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports